import { useState } from "react"
import { ApprovalContext } from "."

const ContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [isImageLoading, setIsImageLoading] = useState(false)

  const setImageLoader = (val: boolean) => {
    setIsImageLoading(val)
  }

  return (
    <ApprovalContext.Provider value={{
      isImageLoading,
      setImageLoader
    }}>{children}</ApprovalContext.Provider>
  )
}

export default ContextProvider
